(() => {
  // app/scripts/filter-toolbar.js
  var FilterToolbar = class extends HTMLElement {
    constructor() {
      super();
      this.callbacks = [];
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.initSortBy();
    }
    initSortBy() {
      const sortByElms = this.querySelectorAll(".js-sort-by");
      sortByElms.forEach((sortByElm) => {
        sortByElm.addEventListener("change", (event) => {
          const value = event.target.value;
          sortByElms.forEach((sortByElm2) => {
            sortByElm2.value = value;
          });
          this.dispatch({ sort_by: value });
        });
      });
    }
    dispatch(value) {
      this.callbacks.forEach((callback) => {
        callback(value);
      });
    }
    onChange(callback) {
      this.callbacks.push(callback);
    }
    updateLayout(filterToolbarElm) {
      this.innerHTML = filterToolbarElm.innerHTML;
      this.init();
    }
  };
  if (!customElements.get("filter-toolbar")) {
    customElements.define("filter-toolbar", FilterToolbar);
  }
})();
